import React from 'react'

const EqualOpportunityHousingLogo = () => {
	return (
		<svg
			viewBox="0 0 62 62"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M31 1L0 16.9067V23.3815L3.42964 23.4261V46.6092H58.3394L58.3083 23.3815H62V16.9067L31 1ZM52.2264 40.4906H9.53812V19.868L31 8.77075L52.222 19.868V40.4906H52.2264ZM20.8533 25.7328H40.9646V19.7211H20.8533V25.7328ZM20.8533 35.3026H40.8758V29.2909H20.8533V35.3026Z"
				fill="currentColor"
			/>
			<path
				d="M3.87567 52.6049V53.647H5.77352V54.2348H3.25727V50.4941H5.72021V51.0819H3.87567V52.0331H5.51763V52.6049H3.87567Z"
				fill="currentColor"
			/>
			<path
				d="M10.8451 52.3644C10.8451 52.8347 10.6905 53.2622 10.4346 53.5935L10.7918 53.9409L10.4186 54.331L10.0508 53.9676C9.7576 54.176 9.41641 54.2989 9.04857 54.2989C8.07832 54.2989 7.25201 53.4546 7.25201 52.3644C7.25201 51.2743 8.07832 50.43 9.04857 50.43C10.0135 50.43 10.8451 51.2743 10.8451 52.3644ZM9.04857 53.7218C9.25648 53.7218 9.45373 53.663 9.62965 53.5561L9.12853 53.0645L9.50171 52.6744L10.0135 53.1767C10.1574 52.9576 10.2427 52.6797 10.2427 52.3644C10.2427 51.5682 9.68829 51.0071 9.04857 51.0071C8.40884 51.0071 7.85441 51.5682 7.85441 52.3644C7.85441 53.1607 8.40884 53.7218 9.04857 53.7218Z"
				fill="currentColor"
			/>
			<path
				d="M14.0387 54.2989C13.1697 54.2989 12.5993 53.6683 12.5993 52.8347V50.4941H13.2177V52.8347C13.2177 53.3477 13.5269 53.7057 14.0387 53.7057C14.5505 53.7057 14.8597 53.3477 14.8597 52.8347V50.4941H15.4781V52.8347C15.4781 53.6683 14.9076 54.2989 14.0387 54.2989Z"
				fill="currentColor"
			/>
			<path
				d="M20.3136 54.2348H19.6633L19.3594 53.3958H17.8507L17.5468 54.2348H16.9178L18.3198 50.4941H18.9169L20.3136 54.2348ZM19.1568 52.824L18.6077 51.2904L18.0533 52.824H19.1568Z"
				fill="currentColor"
			/>
			<path
				d="M24.2736 54.2348H21.8853V50.4941H22.5037V53.6416H24.2736V54.2348Z"
				fill="currentColor"
			/>
			<path
				d="M30.532 52.0278V50.4941H31.1504V54.2348H30.532V52.621H28.858V54.2348H28.2396V50.4941H28.858V52.0278H30.532Z"
				fill="currentColor"
			/>
			<path
				d="M34.7286 54.2989C33.7583 54.2989 32.932 53.4546 32.932 52.3644C32.932 51.2743 33.7583 50.43 34.7286 50.43C35.6935 50.43 36.5251 51.2743 36.5251 52.3644C36.5251 53.4546 35.6935 54.2989 34.7286 54.2989ZM34.7286 53.7057C35.3576 53.7057 35.9067 53.15 35.9067 52.3644C35.9067 51.5789 35.3576 51.0232 34.7286 51.0232C34.0995 51.0232 33.5504 51.5789 33.5504 52.3644C33.5504 53.15 34.0995 53.7057 34.7286 53.7057Z"
				fill="currentColor"
			/>
			<path
				d="M39.7187 54.2989C38.8497 54.2989 38.2793 53.6683 38.2793 52.8347V50.4941H38.8977V52.8347C38.8977 53.3477 39.2069 53.7057 39.7187 53.7057C40.2305 53.7057 40.5397 53.3477 40.5397 52.8347V50.4941H41.1581V52.8347C41.1581 53.6683 40.5876 54.2989 39.7187 54.2989Z"
				fill="currentColor"
			/>
			<path
				d="M44.2692 54.2989C43.4429 54.2989 42.9365 53.7859 42.9045 53.0859H43.5229C43.5602 53.4706 43.8161 53.7378 44.2745 53.7378C44.7224 53.7378 44.9409 53.5187 44.9409 53.2462C44.9409 52.4179 42.9898 52.808 42.9898 51.4774C42.9898 50.8842 43.4482 50.43 44.2266 50.43C44.9889 50.43 45.474 50.9483 45.506 51.611H44.8876C44.8663 51.2476 44.6211 50.9911 44.2266 50.9911C43.8267 50.9911 43.6082 51.2049 43.6082 51.4881C43.6082 52.3003 45.5593 51.8835 45.5593 53.2301C45.5593 53.8393 45.1009 54.2989 44.2692 54.2989Z"
				fill="currentColor"
			/>
			<path
				d="M47.9807 54.2348H47.3623V50.4941H47.9807V54.2348Z"
				fill="currentColor"
			/>
			<path
				d="M52.3283 53.1607V50.4941H52.9307V54.2348H52.3603L50.5744 51.5682V54.2348H49.972V50.4941H50.5424L52.3283 53.1607Z"
				fill="currentColor"
			/>
			<path
				d="M56.577 52.8507V52.3164H58.203V54.2348H57.8245L57.7072 53.7004C57.494 53.9943 57.0675 54.2989 56.5077 54.2989C55.5375 54.2989 54.7112 53.4546 54.7112 52.3644C54.7112 51.2743 55.5375 50.43 56.5077 50.43C57.3767 50.43 58.0058 51.0499 58.1444 51.6858H57.51C57.3874 51.3652 57.0515 51.0232 56.5077 51.0232C55.8787 51.0232 55.3296 51.5789 55.3296 52.3644C55.3296 53.15 55.8787 53.7057 56.5077 53.7057C57.1368 53.7057 57.5046 53.2462 57.5633 52.8507H56.577Z"
				fill="currentColor"
			/>
			<path
				d="M5.50519 61C4.21152 61 3.10977 59.8742 3.10977 58.4207C3.10977 56.9672 4.21152 55.8415 5.50519 55.8415C6.79175 55.8415 7.9006 56.9672 7.9006 58.4207C7.9006 59.8742 6.79175 61 5.50519 61ZM5.50519 60.2091C6.34394 60.2091 7.07607 59.4681 7.07607 58.4207C7.07607 57.3734 6.34394 56.6324 5.50519 56.6324C4.66644 56.6324 3.93431 57.3734 3.93431 58.4207C3.93431 59.4681 4.66644 60.2091 5.50519 60.2091Z"
				fill="currentColor"
			/>
			<path
				d="M9.56422 55.927H11.3412C12.2937 55.927 13.0258 56.6395 13.0258 57.5586C13.0258 58.4849 12.2937 59.1974 11.3412 59.1974H10.3888V60.9145H9.56422V55.927ZM10.3888 58.4065H11.327C11.8175 58.4065 12.2013 58.0502 12.2013 57.5586C12.2013 57.0741 11.8175 56.7179 11.327 56.7179H10.3888V58.4065Z"
				fill="currentColor"
			/>
			<path
				d="M14.6931 55.927H16.4701C17.4226 55.927 18.1547 56.6395 18.1547 57.5586C18.1547 58.4849 17.4226 59.1974 16.4701 59.1974H15.5177V60.9145H14.6931V55.927ZM15.5177 58.4065H16.4559C16.9464 58.4065 17.3302 58.0502 17.3302 57.5586C17.3302 57.0741 16.9464 56.7179 16.4559 56.7179H15.5177V58.4065Z"
				fill="currentColor"
			/>
			<path
				d="M21.9331 61C20.6395 61 19.5377 59.8742 19.5377 58.4207C19.5377 56.9672 20.6395 55.8415 21.9331 55.8415C23.2197 55.8415 24.3285 56.9672 24.3285 58.4207C24.3285 59.8742 23.2197 61 21.9331 61ZM21.9331 60.2091C22.7719 60.2091 23.504 59.4681 23.504 58.4207C23.504 57.3734 22.7719 56.6324 21.9331 56.6324C21.0944 56.6324 20.3622 57.3734 20.3622 58.4207C20.3622 59.4681 21.0944 60.2091 21.9331 60.2091Z"
				fill="currentColor"
			/>
			<path
				d="M29.6599 60.9145H28.7074L27.6412 59.005H26.8167V60.9145H25.9922V55.927H27.9042C28.8496 55.927 29.5391 56.5896 29.5391 57.4802C29.5391 58.1357 29.1126 58.6701 28.4658 58.891L29.6599 60.9145ZM27.89 56.7107H26.8167V58.2497H27.89C28.3734 58.2497 28.7145 57.922 28.7145 57.4874C28.7145 57.0385 28.3734 56.7107 27.89 56.7107Z"
				fill="currentColor"
			/>
			<path
				d="M33.0806 60.9145H32.256V56.7179H30.7775V55.927H34.559V56.7179H33.0806V60.9145Z"
				fill="currentColor"
			/>
			<path
				d="M37.9462 61C36.7876 61 36.027 60.1593 36.027 59.0477V55.927H36.8515V59.0477C36.8515 59.7317 37.2638 60.2091 37.9462 60.2091C38.6286 60.2091 39.0408 59.7317 39.0408 59.0477V55.927H39.8654V59.0477C39.8654 60.1593 39.1048 61 37.9462 61Z"
				fill="currentColor"
			/>
			<path
				d="M44.9163 59.4824V55.927H45.7195V60.9145H44.9589L42.5777 57.3591V60.9145H41.7745V55.927H42.5351L44.9163 59.4824Z"
				fill="currentColor"
			/>
			<path
				d="M48.4915 60.9145H47.667V55.927H48.4915V60.9145Z"
				fill="currentColor"
			/>
			<path
				d="M52.2981 60.9145H51.4736V56.7179H49.9951V55.927H53.7766V56.7179H52.2981V60.9145Z"
				fill="currentColor"
			/>
			<path
				d="M56.7728 58.1571L57.9101 55.927H58.7915L57.1637 59.0192V60.9145H56.3392V59.0192L54.7186 55.927H55.6284L56.7728 58.1571Z"
				fill="currentColor"
			/>
		</svg>
	)
}

export default EqualOpportunityHousingLogo
